export default "__VITE_ASSET__DQIySMmH__"